export default "__VITE_ASSET__CsHfFVzK__"